import React, { useEffect, useState } from "react";
import styles from "./ReadMoreLess.module.css";
import { shorten } from "helpers/Helper";

const ReadMoreLess = ({ text, styleName, textStyle }) => {
  const [readMoreMaxLength, setReadMoreMaxLength] = useState(320);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const updateMaxLength = () => {
      if (window.innerWidth <= 767) {
        setReadMoreMaxLength(75);
      } else {
        setReadMoreMaxLength(320);
      }
    };

    updateMaxLength();
    window.addEventListener("resize", updateMaxLength);

    return () => window.removeEventListener("resize", updateMaxLength);
  }, []);

  // Ensure text is a string before processing
  if (typeof text !== "string") {
    text = "";
  }

  const isLongText = text.length > readMoreMaxLength;
  const displayText = isExpanded || !isLongText ? text : shorten(text, readMoreMaxLength);

  return (
    <div className={styles["read-more-less"]}>
      <p
        className={styleName}
        style={textStyle}
        dangerouslySetInnerHTML={{ __html: displayText }}
      />
      {isLongText ? (
        <button onClick={() => setIsExpanded(!isExpanded)} className={styles["toggle-button"]}>
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      ) : null}
    </div>
  );
};

export default ReadMoreLess;
